<template>
  <div id="contenedor-eliminar-caracteristica-subtipo-infraestructura">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar caracteristica de subtipo infraestructura
      </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la caracteristica del subtipo? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarCaracteristicaSubtipoInfraestructura"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCaracteristicasSubtiposInfraestructura from './mixCaracteristicasSubtiposInfraestructura';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarCaracteristicaSubtipoInfraestructura',
  mixins: [mixCaracteristicasSubtiposInfraestructura],
  props: {
    caracteristicaSubtipoInfraestructuraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
